// Internet Explorer 9 and higher
((arr) => {
	arr.forEach((item) => {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable:   true,
			writable:     true,
			value:        function remove() {
				if (this.parentNode !== null) {
					this.parentNode.removeChild(this);
				}
			},
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);



// WEBPACK FOOTER //
// ./fe/web-default/src/js/polyfill.js